/**
 * Single shared resolver for "what is the current userStore/storage" — every
 * service class and view component that needs to reach the live Zustand
 * userStore or the active StorageInterface without prop drilling should call
 * this instead of hand-rolling its own global-registry lookup. Falls back
 * through the atomic global registry set by `createStoresWithStorage()` in
 * `childNavStores.ts` (`__userStore` / `__proGroupsStores` / `__childNavStores`
 * / `__proGroupsStorage` / `__childNavStorage`), then `window.*` as a last resort.
 */
export function resolveAuthContext(options?: {
  userStore?: any;
  storage?: any;
}): { userStore: any; storage: any } {
  const globalScope = globalThis as any;
  const userStore = options?.userStore
    || globalScope.__userStore
    || globalScope.__proGroupsStores?.useUserStore
    || globalScope.__childNavStores?.useUserStore;

  const storage = options?.storage
    || globalScope.__proGroupsStorage
    || globalScope.__childNavStorage
    || (typeof window !== 'undefined'
      ? (window as any).__proGroupsStorage ?? (window as any).__childNavStorage
      : null);

  return { userStore, storage };
}
